import { useTranslation } from 'react-i18next'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import languages from './languages'
import LanguageIcon from '@mui/icons-material/Language'
import InputAdornment from '@mui/material/InputAdornment'
import useMediaQuery from '@mui/material/useMediaQuery'

const LanguageSwitcher = () => {
  const { i18n } = useTranslation()
  const isMobile = useMediaQuery('(max-width:600px)') // Adjust the breakpoint as needed

  const handleChange = (event) => i18n.changeLanguage(event.target.value)

  return (
    <Select
      value={i18n.language}
      onChange={handleChange}
      displayEmpty
      sx={{
        color: 'white',
        '.MuiSvgIcon-root': {
          color: 'white',
        },
        '& .MuiSelect-icon': {
          color: 'white',
        },
      }}
      renderValue={(selected) => {
        if (isMobile) {
          return null // On mobile, only show the icon
        }
        const selectedLanguage = languages.find(
          (lang) => lang.code === selected
        )
        return selectedLanguage ? selectedLanguage.text : '' // Show full name on desktop
      }}
      startAdornment={
        <InputAdornment position="start">
          <LanguageIcon sx={{ color: 'white' }} />
        </InputAdornment>
      }
    >
      {languages
        .sort((a, b) => a.text.localeCompare(b.text))
        .map((language) => (
          <MenuItem key={language.code} value={language.code}>
            {language.text}
          </MenuItem>
        ))}
    </Select>
  )
}

export default LanguageSwitcher
